import request from '@/utils/request'

// 获取当前机构信息
export function getOrgInfo() {
  return request({
    url: '/organization/info',
    method: 'get'
  })
}

// 更新机构信息
export function updateOrgInfo(data) {
  return request({
    url: '/organization/info',
    method: 'put',
    data
  })
}

// 更新收款账户信息
export function updateBankAccount(data) {
  return request({
    url: '/organization/bank-account',
    method: 'put',
    data
  })
}

// 生成新的推广码
export function generatePromoCode() {
  return request({
    url: '/organization/promo-code/generate',
    method: 'post'
  })
}

// 验证推广码是否有效
export function validatePromoCode(promoCode) {
  return request({
    url: '/organization/promo-code/validate',
    method: 'get',
    params: { promoCode }
  })
}

// 当前用户绑定机构码
export function bindMyPromoCode(promoCode) {
  return request({
    url: '/organization/promo-code/bind',
    method: 'post',
    params: { promoCode }
  })
}

// 获取当前用户已绑定机构列表
export function getMyOrganizations() {
  return request({
    url: '/organization/my-bindings',
    method: 'get'
  })
}

// 获取机构下的用户列表
export function getOrgUsers(params) {
  return request({
    url: '/organization/users',
    method: 'get',
    params
  })
}

// 获取机构下用户的购买记录
export function getOrgUserOrders(params) {
  return request({
    url: '/organization/orders',
    method: 'get',
    params
  })
}

// 获取机构统计数据
export function getOrgStatistics() {
  return request({
    url: '/organization/statistics',
    method: 'get'
  })
}

export function getOrgCourses() {
  return request({
    url: '/organization/course/list',
    method: 'get'
  })
}

// 机构：创建课程并自动创建班级（返回邀请码）
export function createCourseWithClass(data) {
  return request({
    url: '/organization/course/create-with-class',
    method: 'post',
    data
  })
}

export function listOrgTeachers() {
  return request({
    url: '/organization/teachers',
    method: 'get'
  })
}

export function bindOrgTeacher(data) {
  return request({
    url: '/organization/teachers/bind',
    method: 'post',
    data
  })
}

export function unbindOrgTeacher(teacherUserId) {
  return request({
    url: `/organization/teachers/${teacherUserId}`,
    method: 'delete'
  })
}

// ========== 管理员接口 ==========

// 管理员：分页查询所有机构
export function pagingOrganizations(params) {
  return request({
    url: '/organization/admin/list',
    method: 'get',
    params
  })
}

// 管理员：创建机构账号
export function createOrganization(data) {
  return request({
    url: '/organization/admin/create',
    method: 'post',
    data
  })
}

// 管理员：充值推广额度
export function rechargeQuota(orgId, quota) {
  return request({
    url: '/api/organization/admin/recharge',
    method: 'post',
    params: { orgId, quota }
  })
}

// 管理员：更新机构状态
export function updateOrgStatus(orgId, status) {
  return request({
    url: '/organization/admin/status',
    method: 'put',
    params: { orgId, status }
  })
}
